export const dynamicTabsReqs = {
  reporting: {
    role: ['ADMIN', 'BASIC'],
    productTypes: ['BIP'],
  },
  customers: {
    role: ['ADMIN', 'BASIC'],
    productTypes: ['BIP'],
  },
  'goods-receipts': {
    productTypes: ['INVOICE_MANAGEMENT'],
    invoiceManagementRole: ['ADMIN', 'BASIC'],
  },
  invoices: {
    productTypes: ['INVOICE_MANAGEMENT'],
    invoiceManagementRole: ['ADMIN', 'BASIC'],
  },
  orders: {
    productTypes: ['INVOICE_MANAGEMENT'],
    invoiceManagementRole: ['ADMIN', 'BASIC'],
  },
  'account-settings': {
    role: ['ADMIN'],
    productTypes: ['CPG', 'INVOICE_MANAGEMENT'],
    invoiceManagementRole: ['ADMIN'],
  },
  'user-management': {
    role: ['ADMIN'],
    productTypes: ['CPG', 'BIP', 'VPP', 'INVOICE_MANAGEMENT'],
    invoiceManagementRole: ['ADMIN'],
  },
};
